module.exports = __webpack_public_path__ + "media/bj.2dcb21e3.mp4";